/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImageContainer } from '../models/ImageContainer';
import type { LineOaShopConnectionConfig } from '../models/LineOaShopConnectionConfig';
import type { LineOaShopPaymentAlmostDueNotificationConfig } from '../models/LineOaShopPaymentAlmostDueNotificationConfig';
import type { LineOaShopPaymentAppointmentNotificationConfig } from '../models/LineOaShopPaymentAppointmentNotificationConfig';
import type { LineOaShopPaymentConfirmedNotificationConfig } from '../models/LineOaShopPaymentConfirmedNotificationConfig';
import type { LineOaShopPaymentDueTodayNotificationConfig } from '../models/LineOaShopPaymentDueTodayNotificationConfig';
import type { LineOaShopPaymentPastDueNotificationConfig } from '../models/LineOaShopPaymentPastDueNotificationConfig';
import type { LineOaShopWelcomeNotificationConfig } from '../models/LineOaShopWelcomeNotificationConfig';
import type { MessageQuotaResult } from '../models/MessageQuotaResult';
import type { VerificationResult } from '../models/VerificationResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LineOaShopService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves the Line OA welcome notification configuration for a specific shop.
     * @returns LineOaShopWelcomeNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaShopWelcomeNotificationConfig({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LineOaShopWelcomeNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/notification/welcome/config',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA welcome notification configuration for a specific shop.
     * @returns LineOaShopWelcomeNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaShopWelcomeNotificationConfig({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: LineOaShopWelcomeNotificationConfig,
    }): CancelablePromise<LineOaShopWelcomeNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/shops/{shopId}/line-oa/notification/welcome/config',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment past due notification configuration for a specific shop.
     * @returns LineOaShopPaymentPastDueNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaShopPaymentPastDueNotificationConfig({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LineOaShopPaymentPastDueNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-past-due/config',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment past due notification configuration for a specific shop.
     * @returns LineOaShopPaymentPastDueNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaShopPaymentPastDueNotificationConfig({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: LineOaShopPaymentPastDueNotificationConfig,
    }): CancelablePromise<LineOaShopPaymentPastDueNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-past-due/config',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment due today notification configuration for a specific shop.
     * @returns LineOaShopPaymentDueTodayNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaShopPaymentDueTodayNotificationConfig({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LineOaShopPaymentDueTodayNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-due-today/config',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment due today notification configuration for a specific shop.
     * @returns LineOaShopPaymentDueTodayNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaShopPaymentDueTodayNotificationConfig({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: LineOaShopPaymentDueTodayNotificationConfig,
    }): CancelablePromise<LineOaShopPaymentDueTodayNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-due-today/config',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment confirmed notification configuration for a specific shop.
     * @returns LineOaShopPaymentConfirmedNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaShopPaymentConfirmedNotificationConfig({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LineOaShopPaymentConfirmedNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-confirmed/config',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment confirmed notification configuration for a specific shop.
     * @returns LineOaShopPaymentConfirmedNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaShopPaymentConfirmedNotificationConfig({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: LineOaShopPaymentConfirmedNotificationConfig,
    }): CancelablePromise<LineOaShopPaymentConfirmedNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-confirmed/config',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment appointment notification configuration for a specific shop.
     * @returns LineOaShopPaymentAppointmentNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaShopAppointmentNotificationConfig({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LineOaShopPaymentAppointmentNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-appointment/config',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment appointment notification configuration for a specific shop.
     * @returns LineOaShopPaymentAppointmentNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaShopAppointmentNotificationConfig({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: LineOaShopPaymentAppointmentNotificationConfig,
    }): CancelablePromise<LineOaShopPaymentAppointmentNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-appointment/config',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment almost due notification configuration for a specific shop.
     * @returns LineOaShopPaymentAlmostDueNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaShopPaymentAlmostDueNotificationConfig({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LineOaShopPaymentAlmostDueNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-almost-due/config',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment almost due notification configuration for a specific shop.
     * @returns LineOaShopPaymentAlmostDueNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaShopPaymentAlmostDueNotificationConfig({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: LineOaShopPaymentAlmostDueNotificationConfig,
    }): CancelablePromise<LineOaShopPaymentAlmostDueNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/shops/{shopId}/line-oa/notification/payment-almost-due/config',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA connection configuration for a specific shop.
     * @returns LineOaShopConnectionConfig OK
     * @throws ApiError
     */
    public getLineOaShopConnectionConfig({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LineOaShopConnectionConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/config',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA connection configuration for a specific shop.
     * @returns LineOaShopConnectionConfig OK
     * @throws ApiError
     */
    public updateLineOaShopConnectionConfig({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: LineOaShopConnectionConfig,
    }): CancelablePromise<LineOaShopConnectionConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/shops/{shopId}/line-oa/config',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get the rich menu for a specific shop.
     * @returns ImageContainer OK
     * @throws ApiError
     */
    public getLineOaRichMenuImage({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ImageContainer> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/rich-menu/image',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Set the rich menu for a specific shop.
     * @returns any OK
     * @throws ApiError
     */
    public setLineOaRichMenuImage({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: ImageContainer,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/shops/{shopId}/line-oa/rich-menu/image',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get the message quota for a specific shop.
     * @returns MessageQuotaResult OK
     * @throws ApiError
     */
    public getLineOaMessageQuota({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<MessageQuotaResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/message-quota',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Verifies the Line OA configuration for a specific shop.
     * @returns VerificationResult OK
     * @throws ApiError
     */
    public verifyLineOaConfig({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<VerificationResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/line-oa/config/verify',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
